import Cookies from "js-cookie";
import { API } from "@/lib/api";

/**
 * Trasforma una path object-storage (es. "vista/uploads/.../foo.jpg")
 * restituita dal manifest social in URL HTTPS autenticata via
 * `/api/files?path=...&auth=token`.
 *
 * Lascia invariate:
 *  - URL già assolute (http://, https://)
 *  - asset statici frontend (/landing/, /static/)
 *
 * Necessario perché le path nude del manifest non sono direttamente
 * raggiungibili dal browser (la SPA fallback restituisce index.html
 * invece dell'immagine).
 *
 * @param {string} url
 * @returns {string}
 */
export function resolveManifestPhotoUrl(url) {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/landing/") || url.startsWith("/static/")) return url;
  const token = Cookies.get("vista_jwt") || "";
  const qs = new URLSearchParams({ path: url });
  if (token) qs.append("auth", token);
  return `${API}/files?${qs.toString()}`;
}

/**
 * Trasforma `manifest.property` in modo che `photos[].url` sia
 * direttamente accessibile dal browser (preview live + html2canvas).
 *
 * @param {object|null|undefined} property
 * @returns {object|null|undefined}
 */
export function resolveManifestProperty(property) {
  if (!property) return property;
  const photos = (property.photos || []).map((ph) => ({
    ...ph,
    url: resolveManifestPhotoUrl(ph?.url),
  }));
  return { ...property, photos };
}

/**
 * Trasforma `manifest.agency` in modo che `logo_url` sia accessibile
 * dal browser come URL HTTPS firmata.
 *
 * Casi:
 *  - URL già assoluta http(s) → invariato
 *  - Path `/api/public/...` → restituito così com'è (proxy frontend OK)
 *  - Path object-storage raw (es. "vista/agency/USER/logo.png") → firmata
 *    via /api/files?path=...&auth=TOKEN per garantire accesso CORS-friendly
 *    e auth-aware al PDF generator.
 *
 * @param {object|null|undefined} agency
 * @returns {object|null|undefined}
 */
export function resolveManifestAgency(agency) {
  if (!agency) return agency;
  const logo = agency.logo_url;
  if (!logo) return agency;
  if (logo.startsWith("http://") || logo.startsWith("https://")) return agency;
  if (logo.startsWith("/api/")) return agency;
  // Path raw object-storage: firma con /api/files
  return { ...agency, logo_url: resolveManifestPhotoUrl(logo) };
}
